import UserAPICore from './UserAPICore';

class UserFriendListAPI extends UserAPICore {
}

export default UserFriendListAPI;
